import { Outlet } from "react-router-dom";
import BillingStatusBanner from "../billing/BillingStatusBanner";
import MobileDownloadFirstAccessDialog from "../help/MobileDownloadFirstAccessDialog";
import Sidebar from "./Sidebar";
import { useAuth } from "../../providers/auth-provider";

export default function AppShell() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className="flex min-h-screen items-start bg-slate-50">
      <Sidebar />
      <main className="min-w-0 flex-1 py-10 pb-24 md:pb-10 print:p-0">      
        <div className="px-4 sm:px-6 lg:px-8">
          <BillingStatusBanner role={user.role} />
          <Outlet />
        </div>
      </main>
      <MobileDownloadFirstAccessDialog open={!user.mobileDownloadNoticeAcknowledged} />
    </div>
  );
}
